import { type CSSProperties, FC } from 'react';
import type { SvgProps } from 'react-native-svg';

export type IllustrationSource = FC<SvgProps>;

export interface Props extends Omit<SvgProps, 'style'> {
	source: IllustrationSource;
	style?: CSSProperties;
}

export const Illustration: FC<Props> = ({ source: SourceComponent, style, ...rest }) => (
	<SourceComponent style={{ flexShrink: 0, ...(style ?? {}) }} {...rest} />
);
